import React from "react";
import PropTypes from "prop-types";
import { Grid, FormControlLabel, Checkbox } from "@mui/material";
import { TextField, Autocomplete } from "@totalsoft/rocket-ui";
import { DateTime } from "@ts-private/rocket-extensions";
import { onCheckBoxChange } from "utils/propertyChangeAdapters";
import { useTranslation } from "react-i18next";

const FiltersComponent = ({ filters, onPropertyChange, validDate, levels }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={6} lg={3}>
        <TextField
          fullWidth
          value={filters.correlationId || ""}
          name="correlationId"
          label={t("Logs.CorrelationId")}
          onChange={onPropertyChange("correlationId")}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} lg={3}>
        <TextField
          fullWidth
          value={filters.message || ""}
          name="message"
          label={t("Logs.Message")}
          onChange={onPropertyChange("message")}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} lg={3}>
        <DateTime
          fullWidth
          value={filters.startDate}
          label={t("Logs.StartDate")}
          onChange={onPropertyChange("startDate")}
          timeFormat={false}
          disabled={false}
          isValidDate={validDate}
        />
      </Grid>

      {filters.startDate ? (
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <DateTime
            showPicker={"time"}
            value={filters.startTime}
            label={t("Logs.StartTime")}
            onChange={onPropertyChange("startTime")}
          />
        </Grid>
      ) : null}

      <Grid item xs={12} sm={6} md={6} lg={3}>
        <DateTime
          fullWidth
          value={filters.endDate}
          label={t("Logs.EndDate")}
          onChange={onPropertyChange("endDate")}
          disabled={false}
          isValidDate={validDate}
          timeFormat={false}
        />
      </Grid>

      {filters.endDate ? (
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <DateTime
            showPicker={"time"}
            value={filters.endTime}
            label={t("Logs.EndTime")}
            onChange={onPropertyChange("endTime")}
          />
        </Grid>
      ) : null}

      <Grid item xs={12} sm={6} md={6} lg={3}>
        <Autocomplete
          fullWidth
          value={filters.level}
          onChange={onPropertyChange("level")}
          label={t("Logs.Level")}
          simpleValue={true}
          valueKey="id"
          id="name"
          name="level"
          options={levels}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} lg={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.onlyWithCorrelationId}
              onChange={onCheckBoxChange(onPropertyChange("onlyWithCorrelationId"))}
              color="primary"
              name="onlyWithCorrelationId"
            />
          }
          label={t("Logs.IncludeMessagesWithCorrelationIds")}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} lg={3}>
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.showLogEvent}
              onChange={onCheckBoxChange(onPropertyChange("showLogEvent"))}
              color="primary"
              name="showLogEvent"
            />
          }
          label={t("Logs.IncludeLogEvent")}
        />
      </Grid>
    </Grid>
  );
};

FiltersComponent.propTypes = {
  filters: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  validDate: PropTypes.func.isRequired,
  levels: PropTypes.array.isRequired
};

export default FiltersComponent;
